import { isOnPrem } from '@/utils/buildProfile';
import dynamic from 'next/dynamic';
import type { ComponentType, ReactNode } from 'react';

export interface MergeConnectButtonProps {
  /** Required by Merge Link token API — which connector to authenticate. */
  connector: string;
  /** Shorter “Connect” label for table rows (default: “Connect {app}”). */
  compact?: boolean;
  /** Fired after Merge Link succeeds (in-chat connect chips). */
  onConnected?: () => void;
  /** Fired when Link token creation or the Link SDK errors. */
  onFailed?: () => void;
  onBusyChange?: (busy: boolean) => void;
  disabled?: boolean;
  /** Replaces the default Connect copy. */
  children?: ReactNode;
}

/**
 * On-prem guardrail F1: `@mergeapi/react-agent-handler-link` phones home to
 * ah-cdn.merge.dev. `isOnPrem` is build-time folded, so the `dynamic(...)`
 * branch (and its import factory) must be absent from the on-prem module
 * graph — not merely skipped at render time.
 */
const MergeConnectButtonOnPremStub: ComponentType<MergeConnectButtonProps> = () => null;

const MergeConnectButtonImpl: ComponentType<MergeConnectButtonProps> = isOnPrem
  ? MergeConnectButtonOnPremStub
  : dynamic(
      () => import('./merge-connect-button-impl').then((m) => m.MergeConnectButtonImpl),
      { ssr: false }
    );

export function MergeConnectButton(props: MergeConnectButtonProps) {
  return <MergeConnectButtonImpl {...props} />;
}
